// Possible backend given values and their class names
export enum GalleryGridSizes {
  third = "col-span2",
  half = "col-span3",
  twoThirds = "col-span4",
  full = "col-span6",
}
